__turbopack_context__.v({
  "section-0": "style-module-scss-module__Saea6q__section-0",
  "section-1": "style-module-scss-module__Saea6q__section-1",
  "section-2": "style-module-scss-module__Saea6q__section-2",
  "section-3": "style-module-scss-module__Saea6q__section-3",
  "section-4": "style-module-scss-module__Saea6q__section-4",
  "section-5": "style-module-scss-module__Saea6q__section-5",
  "section-6": "style-module-scss-module__Saea6q__section-6",
});
